import { useTranslation } from 'react-i18next';
import {
  OPERATOR_DISPLAY_STATUS_LABEL_KEY,
  type OperatorDisplayStatus,
} from '../../lib/dashboard/operatorDisplayStatus';

type OperatorStatusPillProps = {
  status: OperatorDisplayStatus;
};

const TONE: Record<OperatorDisplayStatus, { text: string; dot: string }> = {
  connected: { text: 'var(--gs-ok)', dot: 'var(--gs-ok)' },
  syncing: { text: 'var(--gs-warn)', dot: 'var(--gs-warn)' },
  offline: { text: 'var(--gs-bad)', dot: 'var(--gs-bad)' },
  'not-connected': { text: 'var(--gs-muted)', dot: 'var(--gs-muted)' },
};

/** Plain Connected / Offline / Syncing pill for companion surfaces. */
export function OperatorStatusPill({ status }: OperatorStatusPillProps) {
  const { t } = useTranslation();
  const tone = TONE[status];
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11.5px] font-semibold"
      style={{
        color: tone.text,
        borderColor: 'var(--gs-line)',
        background: 'var(--gs-canvas)',
      }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: tone.dot }} aria-hidden />
      {t(OPERATOR_DISPLAY_STATUS_LABEL_KEY[status])}
    </span>
  );
}
